import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";
import PageViewer from "../builder/PageViewer";
import HeaderFooterLayout from "../layouts/HeaderFooterLayout";
import styles from "./EventPreview.module.css";

const EventPreview = () => {
    const { eventId } = useParams();
    const navigate = useNavigate()
    const [event, setEvent] = useState(null)

    const getEvent = async () => {
        try {
            let event = await api.get(`/admin/events/${eventId}`)
            setEvent(event)

        }
        catch (e) {

            console.error(e)
            navigate("/404")
        }
    }
    useEffect(() => {
        getEvent()
    }, [eventId])

    useEffect(() => {
        window.scrollTo({
            top: 0,
        })

    }, [])

    return (
        <HeaderFooterLayout hideFooter>
            <div className={styles.container}>
                {event &&
                    <PageViewer page={event.content} />
                }
            </div>

        </HeaderFooterLayout>
    )
}

export default EventPreview
